// This middleware starts the loader before the request is dispatched.

import store from '@/store';

export default {
  async applyMiddleware(data, next) {
    await store.dispatch('incrementLoader');
    next();
  },
};



// WEBPACK FOOTER //
// ./api/middlewares/loader.js